import { Groups, GroupLedger, DayBook, LedgerDetails, MonthlyLedger, Stock, MonthlyIncomeExpense, MyPending, BankInOut } from "../Components/index.js";

export default [
    // // Stock
    {
        path: "/report/account/stock",
        component: Stock,
        name: "report.account.inventory.stock",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/report/production-cost', component: ProductionCost, name: 'report.production'},

    {
        path: "/report/account/day-book",
        component: DayBook,
        name: "report.account.daybook",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/account/day-book-removed",
        component: DayBook,
        name: "report.account.daybook.removed",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/report/sales/:id/view', component: DisplayVoucher, name: 'report.sale.view'},

    // //Account Info
    // {path: '/report/account/item-voucher-details', component: ItemsVoucherDetails, name: 'report.product.voucher.details'},
    {
        path: "/report/account/ledger",
        component: LedgerDetails,
        name: "report.account.LedgerDetails",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/account/ledger/my-pending",
        component: MyPending,
        name: "report.account.Ledger.mypending",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/account/monthly-ledger/:id",
        component: MonthlyLedger,
        name: "report.account.MonthlyLedger",
        meta: {
            requiresAuth: true,
        },
    },

    // //Account Group
    {
        path: "/report/account/group",
        component: Groups,
        name: "report.account.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/account/group/:id?",
        component: GroupLedger,
        name: "report.account.group.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/account/ledger/:id",
        component: GroupLedger,
        name: "report.account.ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/account/monthly-income-expense",
        component: MonthlyIncomeExpense,
        name: "report.account.monthly.income.expense",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/account/monthly-bank-in-out",
        component: BankInOut,
        name: "report.account.monthly.bank.in.out",
        meta: {
            requiresAuth: true,
        },
    },
];
